<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" type="success" plain @click="importClass" v-if="!isMB">导入</el-button>
        <el-button size="mini" type="primary" plain @click="exportClass" v-if="!isMB">导出</el-button>
        <el-button size="mini" type="primary" @click="create">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="isMB?60:80">
          <template slot-scope="{row}">
            <el-button type="text" @click="editById(row.ClassId)" size="medium" icon="el-icon-edit-outline" title="编辑"></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/ed/class/list";
import editDialog from "@/components/ed/class/editDialog";
import importDialog from "@/components/ed/class/importDialog";

export default {
  name: "class",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    importClass() {
      this.$refs.importDialog.TermId = sessionStorage.getItem("termId");
      this.$refs.importDialog.TermName = sessionStorage.getItem("termName");
      this.$refs.importDialog.open();
    },
    exportClass() {
      this.$refs.list.export();
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ClassId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>